module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iaS1pbXBvcnQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDMyIDMyIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudGNvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+CiAgICA8cGF0aCBkPSJNMjggMjIgTDI4IDMwIDQgMzAgNCAyMiBNMTYgNCBMMTYgMjQgTTggMTYgTDE2IDI0IDI0IDE2IiAvPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-import.svg
// module id = zY7Y
// module chunks = 53